// extracted by mini-css-extract-plugin
module.exports = {"root":"CompactBriefDesktop_root__gYwRn","footerText":"CompactBriefDesktop_footerText__iMGRu"};